import React from 'react';
import { SSOCallback } from '../SSOCallback/SSOCallback';

/**
 * Microsoft OAuth Callback Handler
 *
 * This component handles the OAuth callback from Microsoft Azure AD.
 * It delegates to the generic SSOCallback component which handles all SSO providers.
 */
export const MicrosoftCallback = (): React.ReactElement | null => {
  return <SSOCallback provider='microsoft' callbackPath='/auth/microsoft/callback' />;
};
